import React from 'react'
import { Space, Tooltip } from 'antd'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconDocument } from '../../../../shared/components/icons/IconDocument'
import { IconEdit } from '../../../../shared/components/icons/IconEdit'
import { IconEye } from '../../../../shared/components/icons/IconEye'
import { IconEyeOff } from '../../../../shared/components/icons/IconEyeOff'
import { usePostAffiliateHideMutation } from '../../../../app/api'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { LastAdReport } from '../../widgets/last-ad-report/LastAdReport'
import { EditAffiliateModal } from '../../widgets/edit-affiliate-modal/EditAffiliateModal'
import { useTranslation } from 'react-i18next'

interface ActionsCellProps {
  id: number
  ads_count: number
  is_hidden: boolean
  affiliate: string
  project: string
  onRefetch: () => void
}

export const ActionsCell = ({
  id,
  ads_count,
  is_hidden,
  affiliate,
  project,
  onRefetch,
}: ActionsCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [hide] = usePostAffiliateHideMutation()

  return (
    <Space>
      <Tooltip title={t('buttons.other.showLatestAffiliateAdTooltip')}>
        <div>
          <IconButton
            size='lg'
            onClick={() => {
              dispatch(
                setModal({
                  size: 'lg',
                  children: <LastAdReport adsCount={ads_count} affiliate={affiliate} id={id} />,
                }),
              )
            }}
          >
            <IconDocument color='#A059FF' />
          </IconButton>
        </div>
      </Tooltip>
      <Tooltip title={t('buttons.other.editAffiliateProfileTooltip')}>
        <div>
          <IconButton
            size='lg'
            onClick={() => {
              dispatch(
                setModal({
                  children: <EditAffiliateModal callback={onRefetch} id={id} projectId={project} />,
                }),
              )
            }}
          >
            <IconEdit color='#A059FF' />
          </IconButton>
        </div>
      </Tooltip>
      <Tooltip title={is_hidden ? t('buttons.unhide') : t('buttons.hide')}>
        <div>
          <IconButton
            size='lg'
            onClick={() =>
              hide({ body: { id, is_hidden: !is_hidden } }).then(() => onRefetch())
            }
          >
            {is_hidden ? <IconEye color='#A059FF' /> : <IconEyeOff color='#A059FF' />}
          </IconButton>
        </div>
      </Tooltip>
    </Space>
  )
}
